import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled from 'styled-components'

export const StyledImageCardFlags = styled(Flexbox)`
    flex-wrap: wrap;
    width: 100%;
`
